// Platform
import { CerFormView } from '@form/cer-form-view';
import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class ContractLegacyForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    viewSet.add(ContractLegacyForm.contractViewGet());
  }

  public static contractViewGet(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'kontrakter-alle', text: 'Kontrakter', textSingular: 'Kontrakt',
        dataApiName: 'ContractLegacy', dataApiParams: ['$includeDataLinks'],
        primaryKey: 'id',
        allowEdit: false, allowCreate: false, allowDelete: false,
        titleFields: ['hkontraktStr', 'bogtitel'],
        navigations: [
          { link: 'navMenu', foreignKey: { entity: 'RefDataProductLookup', column: 'contractNum', parentColumn: 'hkontraktStr' } }
        ]
      },
      fieldMetadata: [
        { name: 'id', text: 'Id', tooltipText: 'Unik nøgle for posten', allowEdit: false, visible: false },
        { name: 'hkontraktStr', text: 'Kontrakt', tooltipText: 'Kontraktnr.', widthType: FieldWidthEnum.S, allowEdit: false, filterOperator: 'startswith', orderBy: 'Descending' },
        { name: 'bogtitel', text: 'Titel', tooltipText: 'Titel', widthType: FieldWidthEnum.XL, allowEdit: false },
        { name: 'isbn', text: 'ISBN (primær)', tooltipText: 'ISBN på hovedudgivelse', widthType: FieldWidthEnum.S, allowEdit: false },
        { name: 'redaktorNavn', text: 'Redaktør', tooltipText: 'Redaktørnavn', widthType: FieldWidthEnum.S, allowEdit: false },
        { name: 'gruppeNavn', text: 'Kategori intern', widthType: FieldWidthEnum.S, allowEdit: false },
        { name: 'formaalNavn', text: 'Formål', tooltipText: 'Formål', widthType: FieldWidthEnum.S, allowEdit: false, visible: false },
        { name: 'kontraktType', text: 'Kontrakttype', tooltipText: 'Type af kontrakt', widthType: FieldWidthEnum.S, allowEdit: false, filterOnClient: true, filterOperator: 'notequal', filterValue: 'Lukkede' },
        { name: 'afregningstypeNavn', text: 'Afregn.type', tooltipText: 'Type for afregning', widthType: FieldWidthEnum.S, allowEdit: false, visible: false },
        { name: 'afregnTerminNavn', text: 'Afregn. termin', tooltipText: 'Termin for afregning', widthType: FieldWidthEnum.S, allowEdit: false, visible: false },
        { name: 'forfatterId', text: 'Forfatter/Opr. forlag ID', tooltipText: 'Forfatter eller opr. forlag', widthType: FieldWidthEnum.S, allowEdit: false },
        { name: 'forfatterNavn', text: 'Forfatter/Opr. forlag navn', tooltipText: 'Navn på forfatter eller opr. forlag', widthType: FieldWidthEnum.M, allowEdit: false },
        { name: 'agent', text: 'Agent ID', tooltipText: 'Agent ID', widthType: FieldWidthEnum.S, allowEdit: false },
        { name: 'agentNavn', text: 'Agent', tooltipText: 'Navn på agent', widthType: FieldWidthEnum.M, allowEdit: false },
        { name: 'oprindeligTitel', text: 'Opr. titel', tooltipText: 'Oprindelig titel', widthType: FieldWidthEnum.M, allowEdit: false },
        { name: 'oprindeligForfatter', text: 'Opr. forfatter', tooltipText: 'Navn på opr. forfatter', widthType: FieldWidthEnum.M, allowEdit: false },
      ]
    });
  }
}
